/**
 * Normalizes any string into a consistent kebab-case test ID.
 *
 * Rules applied in order:
 *   1. Trim surrounding whitespace
 *   2. Lowercase the whole string
 *   3. Replace spaces and underscores with a single hyphen
 *   4. Remove any character that is not a-z, 0-9, or hyphen
 *   5. Collapse consecutive hyphens into one
 *   6. Strip leading / trailing hyphens
 *
 * Examples:
 *   tid('create_user_save')            → 'create-user-save'
 *   tid('users_container_table')       → 'users-container-table'
 *   tid(`create-user-First Name`)      → 'create-user-first-name'
 *   tid(`operator_Sub Application ID`) → 'operator-sub-application-id'
 *   tid('sc-actions-abc-123')          → 'sc-actions-abc-123'   (already clean)
 *
 * Usage in components / pages:
 *   import { tid } from '@/utils/testId';
 *   <input data-testid={tid(`create-user-${USER_PROPS.FIRST_NAME.LABEL}`)} />
 */
export function tid(id: string): string {
    const normalized = id
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-{2,}/g, '-')
        .replace(/^-+|-+$/g, '');
    return normalized ? `gw-${normalized}` : '';
}
